import { render, staticRenderFns } from "./ProfileStatsMobile.vue?vue&type=template&id=66d39c19&scoped=true&"
import script from "./ProfileStatsMobile.vue?vue&type=script&lang=js&"
export * from "./ProfileStatsMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d39c19",
  null
  
)

export default component.exports